<template>

    <v-container class="pa-0">

        <template>
          <v-progress-linear v-if="timeToWait === true && datenschutztext.length === 0" color="red" :indeterminate="true"></v-progress-linear>
        </template>

        <v-layout row wrap v-if="thereIsAnError">
            <v-flex>
                Die Daten konnten nicht abgerufen werden. Fehler 404.
            </v-flex>
        </v-layout>

        <v-layout v-if="datenschutztext">
            <v-flex xs12>

                <div v-html="datenschutztext"></div>

            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    export default {
        name: 'datenschutz',

        data: () => ({
            datenschutztext: "",
            timeToWait: false,
            thereIsAnError: false
        }),

        methods: {

        },

        beforeCreate() {

            const vu = this;
            let myTimeout = window.setTimeout(function(){
                vu.timeToWait = true;
            }, 1500);

            this.axios.get("https://apiv1.software-schiek.de/datenschutz")
                .then( (response) => {
                    vu.timeToWait = false;
                    window.clearTimeout(myTimeout);
                    this.datenschutztext = response.data;
            }).catch(() => {
                vu.thereIsAnError = true;
                vu.timeToWait = false;
                window.clearTimeout(myTimeout);
            })

        }

    }
</script>

<style scoped>

</style>
